module.exports = __webpack_public_path__ + "static/mario2-25620d4c789e7102fa031be8b7dac9d1.jpg";